var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpButtonArrow(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.019,
    height: 36.963,
    viewBox: "0 0 36.019 36.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-up",
    "data-name": "Icon awesome-arrow-up",
    d: "M2.81,23.494.979,21.662a1.972,1.972,0,0,1,0-2.8L17.008,2.828a1.972,1.972,0,0,1,2.8,0L35.834,18.858a1.972,1.972,0,0,1,0,2.8L34,23.486a1.982,1.982,0,0,1-2.83-.033L21.711,13.52V37.23a1.975,1.975,0,0,1-1.98,1.98h-2.64a1.975,1.975,0,0,1-1.98-1.98V13.52L5.64,23.461a1.968,1.968,0,0,1-2.83.033Z",
    transform: "translate(-0.397 -2.246)",
    fill: "#8f6f6f"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpButtonArrow);
export default __webpack_public_path__ + "static/media/upButtonArrow.9c68f85149f5db4e0f514dc534351eab.svg";
export { ForwardRef as ReactComponent };